import { render, staticRenderFns } from "./SendDocumentFilesPreviewModal.vue?vue&type=template&id=6b57f674&scoped=true&lang=pug"
import script from "./SendDocumentFilesPreviewModal.vue?vue&type=script&lang=ts"
export * from "./SendDocumentFilesPreviewModal.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentFilesPreviewModal.vue?vue&type=style&index=0&id=6b57f674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b57f674",
  null
  
)

export default component.exports